import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, Route, Routes } from "react-router-dom";
import { Card, Flex, ActionIcon, Modal, Title } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";

import { ArtistForm } from "@components/Artist";
import { SongList } from "@components/Song";
import { ErrorView, PageTitle, Subnav } from "@components/shared";
import {
  TransferArtist,
  CurateArtist,
  CurationTagManagement,
} from "@components/Curation";

import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

export default function ArtistDetail({ locationId }) {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(false);
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios
      .get(`/artists/${id}/`)
      .then(({ data }) => {
        setInfo(data.response[0]);
      })
      .catch((err) => {
        setError(err);
        setInfo(null);
      });
  }

  if (error) {
    return <ErrorView text={error} />;
  }

  if (!info) return null;

  return (
    <div>
      <PageTitle
        title={
          <Flex align="center" gap="xs">
            <span>{info.name}</span>
            <ActionIcon
              variant="light"
              onClick={() => setEditing(true)}
              radius="xl"
              size="md"
              color="gray"
            >
              <IconEdit size={16} />
            </ActionIcon>
            <TransferArtist artist={info} onSuccess={fetchData} iconButton />
            {!info.is_curated && (
              <CurateArtist
                artist={info}
                onSuccess={fetchData}
                iconButton
                showEdit={false}
              />
            )}
          </Flex>
        }
        subtitle={<React.Fragment>Artist</React.Fragment>}
        icon={entityIcon.artist()}
      />
      <Subnav
        buttonColor={entityColor.artist}
        links={[
          { to: `/artists/${id}`, text: "Detail" },
          { to: `/artists/${id}/songs`, text: "Songs" },
        ]}
      />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <React.Fragment>
              <Modal opened={editing} onClose={() => setEditing(false)}>
                <ArtistForm
                  id={id}
                  name={info.name}
                  onSuccess={() => {
                    fetchData();
                    setEditing(false);
                  }}
                />
              </Modal>
              <Title mb="sm" order={4}>
                Tags
              </Title>
              <Card mb="sm">
                <CurationTagManagement
                  songId={id}
                  items={info.tags}
                  fetchData={fetchData}
                />
              </Card>
            </React.Fragment>
          }
        />
        <Route
          exact
          path="songs"
          element={
            <React.Fragment>
              <SongList artistId={id} locationId={locationId} />
            </React.Fragment>
          }
        />
      </Routes>
    </div>
  );
}
